"use strict";

/**
 * @namespace
 */
gc.gis.error = gc.gis.error || {};

/**
 * @classdesc
 * Basisklasse für Exceptions.
 *
 * @class
 * @extends Error
 * @memberof gc.gis.error
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {string} message Beschreibung des Fehlers
 * @param {Error} [opt_cause] Optionale Ursache dieses Fehlers
 */
gc.gis.error.GCError = function( message, opt_cause )
{
	Error.call( this );

	/**
	 * Klassenname
	 *
	 * @type {string}
	 */
	this.name    = 'gc.gis.error.GCError';
	/**
	 * Beschreibung des Fehlers
	 *
	 * @type {string}
	 */
	this.message = message;
	/**
	 * Optionale Ursache dieses Fehlers
	 *
	 * @type {Error}
	 */
	this.cause   = opt_cause;
	/**
	 * Stacktrace.
	 *
	 * @type {string}
	 */
	this.stack = new Error().stack;
};
gc.gis.error.GCError.prototype = Object.create( Error.prototype );

/**
 * Gibt eine Textrepräsentation dieses Fehlers zurück.
 *
 * @return {string} Textrepräsentation dieses Fehlers
 */
gc.gis.error.GCError.prototype.toString = function()
{
	return this.name +': '+ this.message;
};

